import { Body, Container, Hr, Html, Link, Section, Text } from "@react-email/components";

export const LoadAvailabilityEmail = ({ loadId, origin, destination, pickupDate, deliveryDate, rate, userName, companyName, mcNumber }) => {
    const routeInfo = origin && destination ? `From ${origin} to ${destination}` : "";
    const dateInfo = pickupDate && deliveryDate ? `, picking up on ${pickupDate} and delivering on ${deliveryDate}` : "";
    const rateInfo = rate ? `, for a rate of ${rate}` : "";

    return (
        <Html>
            <Body>
                <Container>
                    <Text>Load #{loadId}</Text>

                    <Section>
                        <Text>Hello! Is this load still available?</Text>

                        <Text>
                            {routeInfo}
                            {dateInfo}
                            {rateInfo}?
                        </Text>

                        <Text>Best regards,</Text>
                        <Text>
                            {userName}, {companyName}
                        </Text>
                        <Text>MC {mcNumber}</Text>
                    </Section>

                    <Hr />

                    <Text>
                        Powered by <Link href="https://cargominds.ai">CargoMinds</Link>
                    </Text>
                    <Text> </Text>
                </Container>
            </Body>
        </Html>
    );
};
